import React from 'react'
import { keyframes } from '@emotion/react'
import styled from '@emotion/styled'
import { Icon } from '@mobi/component-library/Assets/Icon'
import { Button, type ButtonColor } from '@mobi/component-library/Base/Buttons'

type PayIDStatus = 'no-payid' | 'loading' | 'error' | 'retry' | 'generated'

type Props = {
  status: PayIDStatus
  onGenerate: VoidFunction
  disabled?: boolean
  size?: React.ComponentProps<typeof Button>['size']
}

const getButtonState = (status: PayIDStatus): [string, ButtonColor] => {
  if (status === 'loading') return ['Please wait...', 'secondary_color']
  if (status === 'retry') return ['Try again', 'secondary_destructive']
  if (status === 'error') return ['Try again', 'secondary_grey']

  return ['Generate my PayID', 'secondary_color']
}

export const PayIDGenerateButton: React.FC<Props> = ({
  status,
  onGenerate,
  disabled = false,
  size = 'xs',
}) => {
  const [text, color] = getButtonState(status)

  return (
    <Button
      type='button'
      color={color}
      size={size}
      onClick={onGenerate}
      disabled={disabled || status === 'error'}
    >
      {status === 'loading' && (
        <SpinningIconStyled>
          <Icon name='DuocolorLoading01' />
        </SpinningIconStyled>
      )}
      {text}
    </Button>
  )
}

const SpinningIconStyled = styled.span({
  display: 'inline-flex',
  animation: `${keyframes({ to: { transform: 'rotate(360deg)' } })} 1s steps(8) infinite`,
})
